import useCreate from "@/hooks/use-create";
import { UseLoadingReturn } from "@/hooks/use-loading";
import coverageAreaService from "@/services/coverage-area.service";
import { RequestsProps } from "@/types/requests.types";

export interface ImportCoverageArea {
  customerId: number;
}
export type ImportCoverageAreaProps = {
  formData: ImportCoverageArea;
} & RequestsProps;

export type Return = {
  importAreas: (props: ImportCoverageAreaProps) => Promise<ImportCoverageArea[]>;
} & UseLoadingReturn;

const useImportCoverageAreas = (): Return => {
  const fetcher = useCreate<ImportCoverageArea>({
    operation: (f) => coverageAreaService.import(f),
  });
  const { isLoading, startLoading, endLoading, loadingIcon, create } = fetcher;

  return { isLoading, startLoading, endLoading, loadingIcon, importAreas: create };
};

export default useImportCoverageAreas;
